import { render } from "./Sousenkyo.vue?vue&type=template&id=961a30d0&scoped=true"
import script from "./Sousenkyo.vue?vue&type=script&lang=js"
export * from "./Sousenkyo.vue?vue&type=script&lang=js"

import "./Sousenkyo.vue?vue&type=style&index=0&id=961a30d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-961a30d0"]])

export default __exports__